import type { YearOption } from '../types/Dates'

export const generateYearOptions = (
    startYear = 1950,
    endYear = new Date().getFullYear(),
    {
        order = 'desc',
        valueAsString = true
    }: { order?: 'asc' | 'desc'; valueAsString?: boolean } = {},
    isAddAllYears:boolean = false
): YearOption[] => {
    const startYearDefault = 1910

    const from = Math.min(startYearDefault, endYear);
    const to = Math.max(startYearDefault, endYear);
    const years: YearOption[] = [];

    for (let y = from; y <= to; y++) {
        const val = valueAsString ? String(y) : y;
        years.push({ label: String(y), value: val });
    }

    const list = order === 'asc' ? years : years.reverse();

    const labelNull = isAddAllYears ? 'Все года' : 'Выберите год'


    return list
}